module.exports = __webpack_public_path__ + "95330d8b6bc3883330e79577f6c00d34.pdf";